var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeneficioHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.944,
    height: 122.716,
    viewBox: "0 0 153.944 122.716",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.021 18.187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.748,865.6a4.335,4.335,0,0,1-3.078-1.269c-8.488-8.508-8.7-22.119-.481-30.362a20.606,20.606,0,0,1,6.944-4.551,4.344,4.344,0,1,1,3.221,8.068,11.992,11.992,0,0,0-4.019,2.638c-4.837,4.837-4.623,12.937.491,18.05a4.357,4.357,0,0,1-.01,6.156A4.312,4.312,0,0,1,328.748,865.6Z",
    transform: "translate(-319.16 -829.111)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.16,950.048a4.31,4.31,0,0,1-3.068-1.267l-56.1-56c-15.135-15.135-15.35-39.566-.481-54.445,14.869-14.859,39.29-14.634,54.436.481l5.185,5.194,5.236-5.206c15.145-15.1,39.556-15.329,54.425-.469A37.63,37.63,0,0,1,458.784,865.5a4.037,4.037,0,0,1-4.4,4.305,4.326,4.326,0,0,1-4.3-4.377,28.979,28.979,0,0,0-8.447-20.944c-11.494-11.474-30.383-11.249-42.143.491l-8.314,8.263a4.361,4.361,0,0,1-6.136-.01l-8.263-8.253c-11.75-11.76-30.649-11.954-42.133-.481s-11.27,30.393.481,42.143l53.024,52.933,14.174-14.154a4.346,4.346,0,0,1,6.146,6.146l-17.242,17.222A4.333,4.333,0,0,1,388.16,950.048Z",
    transform: "translate(-317.496 -827.332)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.159 42.551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.14,895.787a32.147,32.147,0,1,1,32.152-32.142A32.168,32.168,0,0,1,358.14,895.787Zm0-55.6a23.46,23.46,0,1,0,23.46,23.46A23.465,23.465,0,0,0,358.14,840.185Z",
    transform: "translate(-326.019 -831.493)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.732 58.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.79,854.053a4.349,4.349,0,0,1-4.346-4.346,17.718,17.718,0,0,1,11.218-16.4,4.35,4.35,0,0,1,3.15,8.11,8.956,8.956,0,0,0-5.686,8.294A4.341,4.341,0,0,1,331.79,854.053Z",
    transform: "translate(-327.444 -833.004)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(131.652 93.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.32,862.134a4.344,4.344,0,0,1-3.406-1.627L331.324,843.49a4.347,4.347,0,0,1,6.79-5.43l13.6,17.017a4.34,4.34,0,0,1-3.395,7.057Z",
    transform: "translate(-330.37 -836.426)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficioHealth);
export default __webpack_public_path__ + "static/media/beneficio-health.307e94701426e993a57cb370e61ff87e.svg";
export { ForwardRef as ReactComponent };